// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal {
  background: rgba(121, 114, 114, 0.78);
}

.popup-header {
  background-color: #3366ff;
  color: white;
}

.popup-header-fontSize {
  font-size: 1.21rem !important;
}`, "",{"version":3,"sources":["webpack://./src/app/system-common/pop-up/pop-up.component.scss"],"names":[],"mappings":"AAAA;EACE,qCAAA;AACF;;AACA;EACE,yBAAA;EACA,YAAA;AAEF;;AAAA;EACE,6BAAA;AAGF","sourcesContent":[".modal {\r\n  background: rgb(121 114 114 / 0.78);\r\n}\r\n.popup-header {\r\n  background-color: #3366ff;\r\n  color: white;\r\n}\r\n.popup-header-fontSize {\r\n  font-size: 1.21rem !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
